<template>
  <section class="w-100 px-4 d-flex flex-column justify-content-center align-items-center">
    <h1 class="font-weight-bold">ご利用ありがとうございました。</h1>
    <p>とどくすりの申込内容はマイページ（<a href="https://my.todokusuri.com/mypage">https://my.todokusuri.com/mypage</a>）よりご確認ください。</p>
  </section>
</template>

<script>
  export default {
    name: 'Thanks'
  }
</script>
